"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const Yup = tslib_1.__importStar(require("yup"));
const hooks_1 = require("../../../../hooks");
const react_2 = require("@osmosys/react");
const ChangePassword_1 = require("./ChangePassword");
const UserProfile = ({ user }) => {
    const { currentUser } = hooks_1.useOsmosysContext();
    const getSchema = () => {
        const schema = {
            email: Yup.string()
                .email('Email address is invalid')
                .lowercase('Must be lowercase')
                .required('Required'),
            fullName: Yup.string()
                .min(2, 'Too short')
                .max(40, 'Too long'),
        };
        return Yup.object().shape(schema);
    };
    return (react_1.default.createElement(react_2.OsmosysSmallContainer, null,
        react_1.default.createElement(reusables_1.Form, { mutationProps: {
                mutation: graphql_1.updateUser,
            }, formikProps: {
                initialValues: {
                    email: user.email || '',
                    fullName: user.fullName || '',
                    isAppAdmin: user.isAppAdmin,
                    workspaces: user.workspaceMemberships.map(wsm => {
                        return wsm.workspace;
                    }),
                },
                validationSchema: () => getSchema(),
            }, valuesToVariables: values => {
                const adminOnlyPayload = currentUser && currentUser.isAppAdmin
                    ? {
                        isAppAdmin: values.isAppAdmin,
                        workspaces: values.workspaces.map(ws => ws.id),
                    }
                    : {
                        isAppAdmin: user.isAppAdmin,
                        workspaces: user.workspaceMemberships.map(wsm => {
                            return wsm.workspace.id;
                        }),
                    };
                return {
                    data: Object.assign({ email: values.email, fullName: values.fullName || '' }, adminOnlyPayload),
                    id: user.id,
                };
            }, showBottomToolbar: true, saveButtonIcon: pro_solid_svg_icons_1.faUserEdit }, (formikProps, mutationResult) => {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(reusables_1.FormGroup, Object.assign({ name: "fullName", label: "Full name", mutationResult: mutationResult }, formikProps)),
                react_1.default.createElement(reusables_1.FormGroup, Object.assign({ name: "email", label: "Email" }, formikProps, { mutationResult: mutationResult })),
                react_1.default.createElement(ChangePassword_1.ChangePassword, { userId: user.id })));
        })));
};
exports.default = UserProfile;
//# sourceMappingURL=index.js.map